import { Drawer } from '@mui/material';
import { CancelIcon } from 'assets/Icons';
import renderIcon from 'icon';
import React from 'react';
import { IoSettingsOutline } from 'react-icons/io5';
import { Logo, Spacer } from '../../atoms';
import CategoriesMenu from '../CategoriesMenu';
import { DrawerHeader } from './styles';

type SideBarProp = {
  side: boolean;
  setSide: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SideBar = ({ side, setSide }: SideBarProp) => {
  const toggleDrawer = (_: any) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setSide(!side);
  };

  return (
    <Drawer
      anchor="left"
      open={side}
      onClose={toggleDrawer(false)}
      sx={{ '.MuiDrawer-paper': { backgroundColor: '#fff' } }}>
      <DrawerHeader>
        <Logo />
        <Spacer width={50} />
        <CancelIcon onClick={() => setSide(false)} />
      </DrawerHeader>
      <Spacer height={30} />

      <div className="p-5 py-5">
        <CategoriesMenu onNavigate={() => setSide(false)} />
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 10,
          left: 0,
          width: '100%',
          padding: '0 20px 24px 20px',
          background: '#fff'
        }}>
        <a
          href="/account"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            textDecoration: 'none',
            color: '#222',
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 0
          }}>
          {renderIcon(IoSettingsOutline, { size: 22 })}
          <span>Settings</span>
        </a>
      </div>
    </Drawer>
  );
};
